// Recovered compiled webpack factory 8567. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "workAsyncStorage", {
      enumerable: !0,
      get: function () {
        return n.workAsyncStorageInstance;
      },
    }));
  let n = r(17828);
}
